<template>
  <v-card>
    <v-toolbar flat color="primary">
      <span class="headline">Send To Tribe</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="card-container">
      <span class="subheading">Tips:</span>
      <v-container class="note-container">
        <v-text-field v-model="tipsNote" readonly></v-text-field>
      </v-container>
    </v-card-text>
    <v-card-actions style="margin-top: -40px">
      <v-btn class="save-button" color="blue darken-1" text @click="showApprovalFormDialog">Approval Form</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="toTribe">Save</v-btn>
    </v-card-actions>
    <v-dialog v-model="approvalFormDialog.display" max-width="1000px" persistent>
      <approval-form-dialog
        :actionType="approvalFormDialog.actionType"
        @hideDialog="hideApprovalFrom"
        @saveUnderwriterApproval="saveUnderwriterApproval"
      ></approval-form-dialog>
    </v-dialog>
  </v-card>
</template>

<script>
import ApprovalFormDialog from './ApprovalFormDialog'
import { DataType, Popup, Tool } from '@/util/index'
import { OriginationBusinessApi } from '@/api/pandaria'
const tool = new Tool()

const popup = new Popup()
export default {
  name: 'to-tribe-no-score-dialog',
  props: {
    loan: Object
  },
  components: {
    ApprovalFormDialog
  },
  data () {
    return {
      tipsNote: 'Approval Form is optional, if necessary, please fill in the approval form before saving',
      dataType: DataType,
      approvalFormDialog: {
        display: false,
        actionType: null,
        data: {}
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  methods: {
    hideDialog () {
      this.approvalFormDialog.data = {}
      this.$emit('hideDialog', 'TO_TRIBE_NO_SCORE')
    },
    toTribe () {
      const $this = this
      const status = DataType.LoanStatus.TRIBE_REVIEW.value
      const request = {
        loanId: $this.loan.id,
        status: status
      }
      if (tool.isNotEmpty(this.approvalFormDialog.data)) {
        this.approvalFormDialog.data.loanId = $this.loan.id
        request.underwriterApproval = this.approvalFormDialog.data
      }
      OriginationBusinessApi.changeLoanStatus(request, function () {
        $this.loan.status = status
        $this.$eventBus.$emit('updateStatus', { status })
        $this.approvalFormDialog.data = {}
        $this.$eventBus.$emit('updateLoanScore', { totalScore: 10 })
        $this.$eventBus.$emit('forceUnlock', { unlockReason: DataType.UnlockLoanReasonEnum.STATUS_CHANGED.value })
        popup.popupForSuccess('Operation is successful')
      }, function (result) {
        popup.popupForWarning(result.message)
      })
      $this.$emit('hideDialog', 'TO_TRIBE_NO_SCORE')
    },
    showApprovalFormDialog () {
      this.approvalFormDialog.actionType = '24001'
      this.approvalFormDialog.display = true
    },
    hideApprovalFrom () {
      this.approvalFormDialog.display = false
    },
    saveUnderwriterApproval (data) {
      this.approvalFormDialog.display = false
      this.approvalFormDialog.data = data
    }
  }
}
</script>

<style scoped>
  .note-container {
    padding-bottom: 0;
    padding-top: 0;
    min-height: 80px;
  }

  .v-textarea textarea {
    resize: none;
  }
</style>
